import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 57738B55-57CB-47EF-9758-32686AA78212
 * name ph
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ph.svg
 * tags
 * - Science 
 * - Home Automation 
 */
export const PhIcon = createSvgIcon(<><path d="M13 7V17H15V13H17V17H19V7H17V11H15V7H13M11 15V13C11 11.9 10.11 11 9 11H5V21H7V17H9C10.11 17 11 16.11 11 15M9 15H7V13H9V15Z" /></>, 'PhIcon');
export default PhIcon